export default __webpack_public_path__ + "static/media/account_image.04692eea.svg";